module.exports = "/fonts/vendor/@bcgov/bootstrap-theme/dist/bc-sans/BCSans-Bold.woff2?70216b6c1c10b8b7ee02643eb56ad62b";